// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"732c2f0a","424":"c9ab6044"}[chunkId] + ".chunk.js";
};